import { ExternalLink } from '../../assets/icons';
import BadgeSquare from '../badge/badgeSquare';

/**
 * One proof of residence permit extension, listed under the permit itself.
 */
const VisaComplementaryDocumentItem = ({
  title,
  validatedType,
  endValidityText,
  sentOnText,
  openLabel,
  onOpen,
}) => (
  <div
    className={'p-2 border rounded h-fit cursor-pointer hover:bg-gray-50'}
    onClick={onOpen}
    role="button"
    tabIndex={0}
    aria-label={openLabel}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onOpen();
      }
    }}
  >
    <div className={'flex justify-between gap-2 select-none'}>
      <div className={'my-auto flex gap-1 min-w-0'}>
        <div className={'my-auto ft-sm truncate'}>{title}</div>
        <div className={'my-auto flex-shrink-0'}>
          <ExternalLink wh={16} color={'#235fe6'} />
        </div>
      </div>
      <div className={'my-auto flex-shrink-0'}>
        <BadgeSquare type={validatedType} />
      </div>
    </div>
    <div
      className={
        'flex flex-wrap justify-between gap-x-2 ft-xs text-gray-500 mt-1'
      }
    >
      <div>{endValidityText}</div>
      {sentOnText && <div>{sentOnText}</div>}
    </div>
  </div>
);

export default VisaComplementaryDocumentItem;
